import React from 'react';
import {StyledCell} from "./index";

const GiftCell  = () => {
    return (
        <StyledCell>
            <img src='/present.png' alt='tree'/>
        </StyledCell>
    );
}

export default GiftCell;
